import { PropertyDto } from '@tallo/property';

import { PropertyOnboardingStep } from '../configs/stages.enum';

type StepValidationData = Partial<PropertyDto> | null | undefined;
type StepValidation = (property: StepValidationData) => boolean;

export const stepValidations: Record<PropertyOnboardingStep, StepValidation> = {
  [PropertyOnboardingStep.ADDRESS]: (property: StepValidationData) => {
    return !!property;
  },
  [PropertyOnboardingStep.PROPERTY_TYPE]: (property: StepValidationData) => {
    return !!property?.specifications?.propertyType;
  },
  [PropertyOnboardingStep.SPECIFICATIONS]: (property: StepValidationData) => {
    return !!property?.specifications?.squareFeet;
  },
  [PropertyOnboardingStep.LEASE_CONDITIONS]: (property: StepValidationData) => {
    return !!property?.leaseConditions;
  },
  [PropertyOnboardingStep.PET_POLICY]: (property: StepValidationData) => {
    return !!property?.petPolicy;
  },
  [PropertyOnboardingStep.LEASE_TERMS]: (property: StepValidationData) => {
    return !!property?.leaseConditions?.desiredLeasingDate && !!property?.leaseConditions?.possibleLeaseTerms;
  },
  [PropertyOnboardingStep.RENTER_REQUIREMENTS]: (property: StepValidationData) => {
    return !!property?.renterRequirements;
  },
  [PropertyOnboardingStep.IMAGES]: (property: StepValidationData) => {
    return !!property?.images?.length;
  },
  [PropertyOnboardingStep.DESCRIPTION]: (property: StepValidationData) => {
    return !!property?.description;
  },
};
